export const CONFIGURATION = 'configuration'
export const CONTEXT = 'context'
